// Trust Scope Empty State Component
// Reusable component for showing the "no scope configured" message

export const ApckTrustScopeEmpty = {
    props: {
        title: {
            type: String,
            default: 'Welcome to Trust Monitor'
        },
        buttonLabel: {
            type: String,
            default: 'Configure Trust Scope'
        },
        buttonIcon: {
            type: String,
            default: 'fa-plus'
        }
    },
    methods: {
        onAction() {
            this.$emit('action');
        }
    },
    template: `
        <ui-layout direction="column" align="center" justify="center" class="dashboard-scope-message py-16">
            <ui-panel-base class="text-center" style="max-width: 600px;">
                <ui-layout direction="column" align="center" justify="center" gap="4" class="py-8">
                    <ui-icon icon="fa-shield-halved" size="lg" type="info" />
                    <ui-heading tag="h2">{{ title }}</ui-heading>
                    <p class="text--secondary">
                        Trust Monitor helps you discover and analyse third-party relationships 
                        and vulnerabilities across all your domains and digital assets.
                    </p>
                    <p class="text--secondary">
                        To get started, add apex domains (e.g., <strong>example.com</strong>) to your 
                        Trust Monitor scope.
                        <br />
                        We will perform subdomain discovery and third-party trust analysis from these seeded domains.
                    </p>
                    <ui-button
                        :label="buttonLabel"
                        :iconLeft="buttonIcon"
                        @click="onAction"
                    />
                </ui-layout>
            </ui-panel-base>
        </ui-layout>
    `
};
